module.exports = __webpack_public_path__ + "static/media/header-knowledge-base.a9873068.svg";